export default __webpack_public_path__ + "static/img01-9c488e2424c247b4edf7ce3c1823131f.webp";